<template>
  <v-container>

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-form ref="form" validation @input="checkValidate" class="ml-3">
      <h1 class="my-3">Изменение данных</h1>

      <v-layout row class="my-4 mx-0">
        <v-flex xs12>
          <v-btn
              class="warning ma-0"
              @click="triggerUpload"
              :loading="uploading"
              :disabled="uploading"
          >
            Загрузить фото
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
          <input
              ref="fileInput"
              type="file"
              style="display: none;"
              accept="image/*"
              @change="onFileChange"
          >
        </v-flex>
      </v-layout>

      <v-layout row class="my-4 mx-0">
        <v-flex xs12 lg8 md8>
          <img :src="avatarSrc" height="150" v-if="avatarSrc">
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs4 lg3 md3>
          <v-text-field
              label="Фамилия"
              v-model="surname"
              :rules="textInputRules"
              validate-on-blur
              outline
              class="mr-3"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 lg3 md3>
          <v-text-field
              label="Имя"
              v-model="firstName"
              :rules="textInputRules"
              validate-on-blur
              outline
              class="mr-3"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 lg3 md3>
          <v-text-field
              label="Отчество"
              v-model="patronymic"
              outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs4 lg3 md3>
          <v-text-field
              label="E-mail"
              v-model="email"
              outline
              class="mr-3"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg6 md6>
          <v-btn
              :loading="loading && !uploading"
              :disabled="!valid || loading || uploading"
              color="primary"
              @click.native="loader = 'loading'"
              class="ma-0"
              @click="onClickUpdateUser"
          >
            Изменить
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Личные данные', link: '/users/self/info'},
        {name: 'Изменить данные'}
      ],
      id: null,
      firstName: null,
      surname: null,
      patronymic: null,
      email: null,
      avatarSrc: '',
      avatarId: null,
      avatarRes: null,
      uploading: false,
      valid: false,
      textInputRules: [
        v => !!v || 'Обязательное поле'
      ]
    }),
    methods: {
      checkValidate () {
        if (this.firstName === null || this.firstName === '') {
          this.valid = false
        } else if (this.surname === null || this.surname === '') {
          this.valid = false
        } else {
          this.valid = true
        }
        return this.valid
      },
      async onClickUpdateUser () {
        let userData = {
          id: this.id,
          firstName: this.firstName,
          surname: this.surname
        }

        if (this.patronymic !== null || this.patronymic !== '') {
          userData.patronymic = this.patronymic
        }
        if (this.email !== null || this.email !== '') {
          userData.email = this.email
        }
        if (this.avatarId !== null && typeof this.avatarId !== 'undefined') {
          userData.avatarId = this.avatarId
        } else {
          userData.avatarId = 0
        }

        await this.$store.dispatch('selfUpdateUser', userData)
          .then((data) => {
            if (typeof data.user !== 'undefined') {
              this.$router.push('/users/self/info')
            }
          })
          .catch(() => {})
      },
      triggerUpload () {
        this.$refs.fileInput.click()
      },
      onFileChange (event) {
        this.avatarRes = event.target.files[0]
        this.uploading = true
        this.$store.dispatch('uploadPhoto', {photo: this.avatarRes})
          .then((data) => {})
          .catch(() => {
            this.uploading = false
          })
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      user () {
        return this.$store.getters.user
      },
      photo () {
        return this.$store.getters.photo
      }
    },
    created () {
      this.$store.commit('setPageTitle', 'Изменение данных')
      if (this.user !== null && this.user !== undefined) {
        this.id = this.user.id
        this.firstName = this.user.first_name
        this.surname = this.user.surname
        this.patronymic = this.user.patronymic
        this.email = this.user.email
        this.avatarId = this.user.photo.id
        this.avatarSrc = this.user.photo.url_resized
      }
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      },
      user (newUser, oldUser) {
        if (this.user !== null && this.user !== undefined) {
          this.id = this.user.id
          this.firstName = this.user.first_name
          this.surname = this.user.surname
          this.patronymic = this.user.patronymic
          this.email = this.user.email
          this.avatarId = this.user.photo.id
          this.avatarSrc = this.user.photo.url_resized
        }
      },
      photo (newPhoto, oldPhoto) {
        this.avatarSrc = this.photo.url_resized
        this.avatarId = this.photo.id
        this.uploading = false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Users/UserSelfEdit.vue